export default "__VITE_ASSET__D1KnZlhN__"